var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNamaazActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 170.123,
    height: 224.995,
    viewBox: "0 0 170.123 224.995",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7969",
    "data-name": "Group 7969",
    transform: "translate(-274.556 -286.883)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39307",
    "data-name": "Path 39307",
    d: "M354.745,385.576V311.5H286.183v74.075",
    transform: "translate(39.154 95.182)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39308",
    "data-name": "Path 39308",
    d: "M407.634,348.251v90l-16.1,16.84H296.617l-16.344-16.956v-126.5l18.113-18.117h92.02l16.96,16.96v23.274",
    transform: "translate(16.304 25.666)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1618",
    "data-name": "Line 1618",
    y1: 15.732,
    transform: "translate(443.18 496.145)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1619",
    "data-name": "Line 1619",
    y1: 15.732,
    transform: "translate(426.824 496.145)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1620",
    "data-name": "Line 1620",
    y1: 15.732,
    transform: "translate(410.111 496.145)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1621",
    "data-name": "Line 1621",
    y1: 15.732,
    transform: "translate(393.403 496.145)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1622",
    "data-name": "Line 1622",
    y1: 15.732,
    transform: "translate(376.69 496.145)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1623",
    "data-name": "Line 1623",
    y1: 15.732,
    transform: "translate(359.978 496.145)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1624",
    "data-name": "Line 1624",
    y1: 15.732,
    transform: "translate(343.266 496.145)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1625",
    "data-name": "Line 1625",
    y1: 15.732,
    transform: "translate(326.553 496.145)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1626",
    "data-name": "Line 1626",
    y1: 15.732,
    transform: "translate(276.056 496.145)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1627",
    "data-name": "Line 1627",
    y1: 15.732,
    transform: "translate(293.129 496.145)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1628",
    "data-name": "Line 1628",
    y1: 15.732,
    transform: "translate(309.841 496.145)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1629",
    "data-name": "Line 1629",
    y1: 15.732,
    transform: "translate(443.18 286.883)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1630",
    "data-name": "Line 1630",
    y1: 15.732,
    transform: "translate(426.824 286.883)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1631",
    "data-name": "Line 1631",
    y1: 15.732,
    transform: "translate(410.111 286.883)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1632",
    "data-name": "Line 1632",
    y1: 15.732,
    transform: "translate(393.403 286.883)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1633",
    "data-name": "Line 1633",
    y1: 15.732,
    transform: "translate(376.69 286.883)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1634",
    "data-name": "Line 1634",
    y1: 15.732,
    transform: "translate(359.978 286.883)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1635",
    "data-name": "Line 1635",
    y1: 15.732,
    transform: "translate(343.266 286.883)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1636",
    "data-name": "Line 1636",
    y1: 15.732,
    transform: "translate(326.553 286.883)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1637",
    "data-name": "Line 1637",
    y1: 15.732,
    transform: "translate(276.056 286.883)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1638",
    "data-name": "Line 1638",
    y1: 15.732,
    transform: "translate(293.129 286.883)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1639",
    "data-name": "Line 1639",
    y1: 15.732,
    transform: "translate(309.841 286.883)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39309",
    "data-name": "Path 39309",
    d: "M276.056,388.069V290.116H443.18v193.53H276.056V401.689",
    transform: "translate(0 12.499)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39310",
    "data-name": "Path 39310",
    d: "M285.575,337.4c-.185-6.015,2.769-11.952,8.784-17.636a2.221,2.221,0,0,0,.253-.272c.044-.053,4.667-5.26,18.205-11.344l.151-.063a27.124,27.124,0,0,0,9.879-7.431,27.13,27.13,0,0,0,9.9,7.441l.126.053c13.431,6.034,18.113,11.241,18.22,11.358a3.072,3.072,0,0,0,.239.258c6,5.665,8.949,11.587,8.784,17.587-.219,7.845-5.7,14-7.81,16.083H293.376C291.259,351.367,285.814,345.269,285.575,337.4Z",
    transform: "translate(36.773 53.245)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39311",
    "data-name": "Path 39311",
    d: "M325.753,368.389H289.5V325.867a2.639,2.639,0,0,1,1.538-2.389l16.5-7.514a.231.231,0,0,1,.18,0l16.5,7.514a2.638,2.638,0,0,1,1.538,2.389Z",
    transform: "translate(51.99 112.367)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNamaazActive);
export default __webpack_public_path__ + "static/media/Namaaz_active.63494fa72da1b0cd95d630c216b255c3.svg";
export { ForwardRef as ReactComponent };